import {Pipe, PipeTransform} from "@angular/core";
import {Temporal} from "temporal-polyfill";
import {PlainDateFormat, TemporalFormatering} from "../tjenester/TemporalFormatering";
import {concat, interval, Observable, of} from "rxjs";
import {map} from "rxjs/operators";
import {PlainDateSerialisert} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {lesPlainDateSerialisertOpt} from "felles-ng2/støttefunksjoner/temporal";
import PlainDate = Temporal.PlainDate;

/**
 * Formaterer PlainDate instans som relativ dato.
 * Se {@link TemporalFormatering#formaterPlainDateRelativ}.
 * Merk at vi returnerer en Observable, så resultatet må pipes til 'async'
 * Eksempel: {{enPlainDateDato | plaindate_relativ:'short':10 | async}}
 */
@Pipe({name: 'plaindate_relativ', pure: true, standalone: true})
export class FormaterPlainDateRelativTimePipe implements PipeTransform {

    constructor(private formatering: TemporalFormatering) {
    }

    transform(dato: PlainDate | PlainDateSerialisert | null, format: PlainDateFormat = 'short', maksRelativOffset = 10): Observable<string> {
        let plainDate = (dato instanceof PlainDate) ?
          dato : lesPlainDateSerialisertOpt(dato);
        return concat(of(null), interval(1000 * 60)) //oppdater ved instansiering, og så hvert 60. sekund
          .pipe(map(() => this.formatering.formaterPlainDateRelativ(plainDate, format, maksRelativOffset)));
    }
}
